import { endOfDay, isWithinInterval, startOfDay, subDays } from 'date-fns'

import { parseCalendarDate } from '@/utils'

export type DateRange = string | { from?: Date; to?: Date }

export interface FilterByDateRangeOptions {
  dateField?: string
}

export function filterByDateRange<T extends Record<string, any>>(
  data: T[],
  dateRange: DateRange,
  options: FilterByDateRangeOptions = {},
): T[] {
  const { dateField = 'date' } = options

  if (dateRange === 'all') return data

  let startDate: Date | null = null
  let endDate: Date = new Date()

  if (typeof dateRange === 'string') {
    const now = new Date()
    switch (dateRange) {
      case '30d':
        startDate = subDays(now, 30)
        break
      case '60d':
        startDate = subDays(now, 60)
        break
      case '90d':
        startDate = subDays(now, 90)
        break
      case '1y':
        startDate = subDays(now, 365)
        break
      default:
        return data
    }
    endDate = now
  } else if (typeof dateRange === 'object' && dateRange !== null) {
    if (!dateRange.from && !dateRange.to) return data

    if (dateRange.from) {
      startDate = startOfDay(dateRange.from)
    }

    if (dateRange.to) {
      endDate = endOfDay(dateRange.to)
    } else if (dateRange.from) {
      endDate = endOfDay(dateRange.from)
    }
  }

  if (!startDate) {
    return data.filter((item) => {
      const itemDate = parseCalendarDate(item[dateField])
      return itemDate <= endDate
    })
  }

  return data.filter((item) => {
    const itemDate = parseCalendarDate(item[dateField])
    return isWithinInterval(itemDate, { start: startDate, end: endDate })
  })
}
